import _ from "lodash"
import React from "react"
import { enumMessages } from "@/utils/MessageUtils"

const RegistrationStatusOptions = _.map(enumMessages("RegistrationStatus"), (message) => {
  return {
    value: message.value,
    label: message.message,
  }
})

class RegistrationStatusInfo extends React.Component {
  render() {
    const { value } = this.props
    let registrationName = ""
    RegistrationStatusOptions.forEach((option) => {
      if (value === option.value) {
        registrationName = option.label
      }
    })

    return <div>{registrationName}</div>
  }
}

export default RegistrationStatusInfo
